import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type FreeTrialCtaProps = CtaShellProps

export function FreeTrialCta(props: FreeTrialCtaProps) {
  return <CtaShell {...props} layout="centered" actionType="free-trial" primaryCta={props.primaryCta ?? { label: "Start free trial", href: "#trial" }} trustMicrocopy={props.trustMicrocopy ?? "No credit card required. Cancel anytime."} />
}
